@for (line of data; track line) {
	<span [class]="className" [appTooltip]="tooltip">{{ line }}</span>
}
